import { useJtSyncStatus } from '../../api/jt-sync.api';
import { useAuthStore } from '../../stores/auth.store';

const ADMIN_ROLES = new Set(['admin', 'operational_admin']);

/**
 * Tells agency admins when Engage's background jobs can't reach JobTetris (JT1-1850), usually
 * because the agency key was revoked or the admin who issued it lost access. An admin opening
 * Engage from JobTetris issues a new key, which clears this.
 */
export function JtConnectionBanner() {
  const role = useAuthStore((s) => s.user?.role ?? '');
  const isAdmin = ADMIN_ROLES.has(role);
  const { data } = useJtSyncStatus({ enabled: isAdmin });
  const credential = data?.credential;

  if (!isAdmin || !credential?.last_failure_at) return null;

  return (
    <div
      role="alert"
      style={{
        backgroundColor: 'var(--color-danger-bg)',
        color: 'var(--color-danger)',
        borderBottom: '1px solid var(--color-danger-border)',
        padding: 'var(--space-2) var(--space-5)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
      }}
    >
      <strong>Engage can't reach JobTetris</strong>, so data syncs and other background work have
      stopped. Open Engage again from JobTetris as an agency admin to reconnect it. If that doesn't
      fix it, check that Engage is switched on for you in JobTetris (Settings → Users).
    </div>
  );
}
